import L from 'leaflet';

let patched = false;

export function ensureLeafletSafeInit() {
  if (patched) return;
  patched = true;

  const proto = (L as any)?.Map?.prototype;
  if (!proto || typeof proto._initContainer !== 'function') return;

  const originalInitContainer = proto._initContainer;

  proto._initContainer = function patchedInitContainer(...args: any[]) {
    const rawContainer = args.length > 0 ? args[0] : (this as any)?._container;
    const container =
      typeof rawContainer === 'string'
        ? (L as any)?.DomUtil?.get?.(rawContainer)
        : rawContainer;

    if (container && (container as any)._leaflet_id) {
      try {
        delete (container as any)._leaflet_id;
      } catch {
        (container as any)._leaflet_id = undefined;
      }
    }

    return originalInitContainer.apply(this, args);
  };
}
